// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as BellADefault } from '../../../../../ui-v3/src/assets/icons/default/alerts_feedback/bell-a.svg?react';
import { ReactComponent as BellASolid } from '../../../../../ui-v3/src/assets/icons/solid/alerts_feedback/BELL-A.svg?react';
import { createIcons } from '../../Icon';
const BellAIcon = /* @__PURE__ */ createIcons('BellA', {
    default: BellADefault,
    solid: BellASolid
});
BellAIcon.supportedTypes = [
    'default',
    'solid'
];
BellAIcon.category = 'alerts_feedback';
export default BellAIcon;
